import React, { forwardRef, useEffect, useMemo, useState } from "react";
import { arrayOf, func, oneOf, string } from "prop-types";

import componentSizes from "../../../../constants/componentSizes";
import { DEFAULT_COUNTRY, PHONE_NUMBER_FIELD_SIZES } from "../../constants";
import getCountryData from "./utilities/getCountryData";
import * as S from "./styled";

const CountryCodeSelect = forwardRef(
  ({ onChange, size, supportedCountries, value, ...passThroughProps }, ref) => {
    const [selectedCountry, setSelectedCountry] = useState(value);

    useEffect(() => {
      setSelectedCountry(value);
    }, [value]);

    const countryData = useMemo(() => getCountryData(supportedCountries), [
      supportedCountries
    ]);

    const handleChange = event => {
      const { value: nextValue } = event.target;

      const { countryCallingCode } = countryData[nextValue];

      setSelectedCountry(nextValue);
      onChange(event, nextValue, { countryCallingCode });
    };

    return (
      <S.Select
        ref={ref}
        onChange={handleChange}
        size={size}
        value={selectedCountry}
        {...passThroughProps}
      >
        {Object.keys(countryData).map(key => {
          const data = countryData[key];
          const {
            countryCallingCode,
            countryFlagEmoji,
            countryISOCode,
            countryName
          } = data;

          let option;

          if (countryISOCode === selectedCountry) {
            option = `${countryFlagEmoji}\u00A0\u00A0\u00A0${countryName}\u00A0\u00A0\u00A0+${countryCallingCode}`;
          } else {
            option = `${countryName}\u00A0\u00A0\u00A0+${countryCallingCode}\u00A0\u00A0\u00A0${countryFlagEmoji}`;
          }

          return (
            <S.Option key={key} value={countryISOCode}>
              {option}
            </S.Option>
          );
        })}
      </S.Select>
    );
  }
);

CountryCodeSelect.displayName = "CountryCodeSelect";

CountryCodeSelect.propTypes = {
  onChange: func,
  size: oneOf(PHONE_NUMBER_FIELD_SIZES),
  supportedCountries: arrayOf(string),
  value: string
};

CountryCodeSelect.defaultProps = {
  onChange: () => {},
  size: componentSizes.MD,
  supportedCountries: [],
  value: DEFAULT_COUNTRY
};

export default CountryCodeSelect;
